import { useEffect, useState, useCallback } from "react";
import { getHeroSlides } from "../services/heroSlidesService";

/**
 * Loads published hero slides from Supabase.
 * Returns { slides, loading, error, refetch }.
 * Consumers should fall back to sensible local defaults on error
 * or while the table is still empty (see Hero/HeroSlider.jsx).
 */
export function useHeroSlides() {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getHeroSlides();
      setSlides(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { slides, loading, error, refetch: load };
}
